import React from 'react';
import { ContactInfoWidget } from './ContactInfoWidget';
import { useContactsData } from '../../../utils/contacts.utils';

export const ContactInfoWidgetContainer = () => {
	const data = useContactsData();
	return <ContactInfoWidget contacts={data} />;
};
